import { AppTabBar } from "./Frames";

const Img = ({ src, className = "" }) => <img src={`/images/${src}_sm.jpg`} alt="" className={`object-cover ${className}`} />;

const HomeScreen = () => (
  <>
    <div className="px-4 pt-2">
      <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--gold)]">Bella Napoli</div>
      <div className="flex justify-between items-end mt-1">
        <div className="font-display text-[22px] leading-tight text-navy">Buongiorno,<br />Giulia</div>
        <span className="chip">340 punti</span>
      </div>
    </div>
    <div className="mx-4 mt-3 relative h-[150px] overflow-hidden rounded-xl">
      <Img src="baba" className="absolute inset-0 w-full h-full" />
      <div className="absolute inset-x-0 bottom-0 p-3 bg-[rgba(20,33,61,0.82)]">
        <div className="text-[9px] uppercase tracking-[0.2em] text-[var(--gold-light)]">Linea Luxury</div>
        <div className="font-display text-[15px] text-[var(--cream)]">Babà all'oro 24k</div>
      </div>
    </div>
    <div className="grid grid-cols-4 gap-2 px-4 mt-3">
      {["Prenota", "Ritira", "Carta", "Negozi"].map((a) => (
        <div key={a} className="quick">
          <i className="block w-3 h-3 rotate-45 border border-[var(--gold)] mx-auto mb-1.5" />
          {a}
        </div>
      ))}
    </div>
    <div className="px-4 mt-3 text-[10px] uppercase tracking-[0.18em] text-[var(--ink-soft)]">Oggi in vetrina</div>
    {[["sfogliatella", "Sfogliatella riccia", "€ 1,80"], ["pastiera", "Pastiera intera 1 kg", "€ 24,00"]].map(([s, n, p]) => (
      <div key={s} className="flex items-center gap-3 mx-4 mt-2 p-2 bg-white rounded-lg">
        <Img src={s} className="w-10 h-10 rounded-md" />
        <div className="flex-1 text-[11px] font-medium text-navy">{n}</div>
        <div className="text-[11px] font-semibold text-[var(--gold)]">{p}</div>
      </div>
    ))}
    <AppTabBar active="Home" />
  </>
);

const BookScreen = () => (
  <>
    <div className="relative h-[150px]">
      <Img src="pastiera" className="w-full h-full" />
    </div>
    <div className="px-4 pt-3">
      <div className="font-display text-[19px] text-navy">Pastiera napoletana</div>
      <div className="text-[11px] text-[var(--ink-soft)]">Intera · 1 kg · ricetta della casa</div>
      <div className="flex justify-between items-center mt-3">
        <span className="font-display text-[20px] text-navy">€ 24,00</span>
        <span className="stepper"><b>–</b>1<b>+</b></span>
      </div>
      <div className="label-sm mt-4">Punto vendita di ritiro</div>
      <div className="field">Il più vicino · 1,2 km <span className="text-[var(--gold)]">Cambia</span></div>
      <div className="label-sm mt-3">Giorno e ora</div>
      <div className="flex gap-1.5 flex-wrap">
        {["Sab 10:00", "Sab 12:00", "Dom 9:30", "Dom 11:00"].map((s, i) => (
          <span key={s} className={`slot ${i === 1 ? "slot--on" : ""}`}>{s}</span>
        ))}
      </div>
      <div className="app-cta mt-4">Conferma ritiro · paga in negozio</div>
      <div className="text-center text-[9.5px] text-[var(--ink-soft)] mt-2">+24 punti fedeltà con questo ordine</div>
    </div>
    <AppTabBar active="Prenota" />
  </>
);

const QR = () => {
  const cells = Array.from({ length: 121 }, (_, i) => ((i * 37 + (i % 7) * 11) % 5 < 2 ? 1 : 0));
  return (
    <svg viewBox="0 0 11 11" className="w-[96px] h-[96px]">
      {cells.map((c, i) => c ? <rect key={`q-${i % 11}-${Math.floor(i / 11)}`} x={i % 11} y={Math.floor(i / 11)} width="1" height="1" fill="#14213D" /> : null)}
      {[[0, 0], [8, 0], [0, 8]].map(([x, y]) => (
        <g key={`${x}${y}`}><rect x={x} y={y} width="3" height="3" fill="#14213D" /><rect x={x + 0.7} y={y + 0.7} width="1.6" height="1.6" fill="#fff" /></g>
      ))}
    </svg>
  );
};

const CardScreen = () => (
  <>
    <div className="px-4 pt-2 font-display text-[20px] text-navy">La tua Carta</div>
    <div className="loyalty mx-4 mt-3">
      <div className="flex justify-between text-[9px] uppercase tracking-[0.2em] text-[var(--gold-light)]">
        <span>Bella Napoli</span><span>Livello Oro</span>
      </div>
      <div className="font-display text-[30px] text-[var(--cream)] mt-3 leading-tight">340</div>
      <div className="text-[10px] text-[rgba(247,241,230,0.7)]">punti · valida nei 7 punti vendita</div>
      <div className="h-1 bg-[rgba(247,241,230,0.2)] rounded mt-3"><div className="h-1 bg-[var(--gold)] rounded w-[68%]" /></div>
      <div className="text-[9.5px] text-[rgba(247,241,230,0.7)] mt-1.5">Mancano 160 punti a un vassoio omaggio</div>
    </div>
    <div className="flex flex-col items-center mt-4">
      <div className="p-2 bg-white rounded-lg"><QR /></div>
      <div className="text-[10px] text-[var(--ink-soft)] mt-2">Mostra il codice alla cassa</div>
    </div>
    <div className="px-4 mt-3 text-[10px] uppercase tracking-[0.18em] text-[var(--ink-soft)]">I tuoi premi</div>
    {[["Caffè e sfogliatella", "120 pt"], ["Vassoio da 500 g", "500 pt"]].map(([n, p]) => (
      <div key={n} className="flex justify-between mx-4 mt-2 p-2.5 bg-white rounded-lg text-[11px]">
        <span className="text-navy font-medium">{n}</span><span className="text-[var(--gold)] font-semibold">{p}</span>
      </div>
    ))}
    <AppTabBar active="Carta" />
  </>
);

const LuxuryScreen = () => (
  <div className="absolute inset-0 bg-[var(--navy)]">
    <Img src="baba" className="w-full h-[290px]" />
    <div className="px-4 pt-4">
      <div className="text-[9px] uppercase tracking-[0.22em] text-[var(--gold-light)]">Linea Luxury · Edizione firmata</div>
      <div className="font-display text-[22px] text-[var(--cream)] mt-1 leading-tight">Babà all'oro alimentare 24k</div>
      <div className="text-[10.5px] text-[rgba(247,241,230,0.72)] mt-1.5 leading-snug">Rum agricolo, crema chantilly alla vaniglia Bourbon, foglia d'oro. Disponibile nelle 3 boutique.</div>
      <div className="flex justify-between items-center mt-3">
        <span className="font-display text-[20px] text-[var(--gold-light)]">€ 8,50</span>
        <span className="app-cta app-cta--gold !mt-0 !w-auto px-4">Prenota</span>
      </div>
    </div>
  </div>
);

export const APP_SCREENS = [
  { key: "home", title: "Home personale", text: "Saluto, punti fedeltà, la Linea Luxury in evidenza e i prodotti del giorno del punto vendita più vicino.", C: HomeScreen },
  { key: "prenota", title: "Prenota e ritira", text: "Il cliente sceglie il prodotto, il negozio e l'orario. Il laboratorio riceve l'ordine nel piano di produzione.", C: BookScreen },
  { key: "carta", title: "Carta fedeltà unica", text: "Una sola carta per i 7 punti vendita: punti, livelli e premi che aumentano la frequenza di acquisto.", C: CardScreen },
  { key: "luxury", title: "Vetrina Luxury", text: "Le creazioni firmate presentate come in boutique, con prenotazione in un tocco.", C: LuxuryScreen },
];
